<div class="dialog">
  <!-- CRM Survey Notifications -->
  <div class="separate-dialog-container">
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'CRM Survey' | translate }} {{ 'Details' | translate }}</h3>
      <div class="dialog__header__action-buttons">
        <div (click)="closeDialog()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
          </span>
        </div>
      </div>
    </header>

    @if (!isLoading) {
      @if (currentSurvey) {
        <div class="dialog__content">
          <section class="survey-details">
            <h3>{{ currentSurvey.title }}</h3>
            <article [innerHTML]="currentSurvey.description" class="mt-10">{{ currentSurvey.description }}</article>
            <div class="flex-row-between-center mt-10 mb-24 text-gray">
              <small
                >{{ 'By' | translate }} <i class="text-orange">{{ currentSurvey.authorEmail }}</i></small
              >
              <small>{{ currentSurvey.surveyStartDate | date: 'dd.MM.yyyy' }}</small>
            </div>
            @if (isUserVoted) {
              <app-alert-message [alertType]="AlertType.SUCCESS" [showCloseIcon]="false" [message]="('Thank you for your vote' | translate) + '!'" size="small"></app-alert-message>
            }
            <div class="survey-details__voting-results">
              <header>
                <h4>{{ 'Voting Results' | translate }}:</h4>
                <small>({{ 'Total Votes' | translate }}: {{ currentSurvey.totalVoteCount }})</small>
              </header>
              @if (currentSurvey.surveyAnswerOptions && currentSurvey.surveyAnswerOptions.length) {
                @for (answer of currentSurvey.surveyAnswerOptions; track answer) {
                  <div class="survey-details__voting-results__result-item">
                    <h4 [tippy]="answer.surveyAnswer">{{ answer.surveyAnswer | humanize | truncateText: 20 }}</h4>
                    <div class="progress-bar">
                      <div [style.width.%]="getAnswerRatioPercentage(answer)" class="progress">
                        @if (getAnswerRatioPercentage(answer) > 9) {
                          <span> {{ getAnswerRatioPercentage(answer) }}% </span>
                        }
                      </div>
                    </div>
                    <p>{{ answer.votedUsersCount || 0 }} {{ 'Votes' | translate }}</p>
                  </div>
                }
              }
            </div>
          </section>
        </div>
      }
      <footer class="dialog__footer">
        <div class="dialog__footer__buttons">
          <app-button
            (click)="closeDialog()"
            [idleText]="'Close' | translate"
            [inlineStyle]="{ border: '1px solid var(--gray)' }"
            backgroundColor="var(--white)"
            borderColor="var(--gray)"
            color="var(--dark-charcoal)"
            width="127px"
          ></app-button>
        </div>
      </footer>
    } @else {
      <div class="dialog__content">
        <ngx-skeleton-loader [theme]="{ height: '150px' }" count="3"></ngx-skeleton-loader>
      </div>
    }
  </div>
</div>
